#version 300 es
/*
* Preprocessed + Optimized from './sepia.frag'
* [Embedded string is compressed]
*/
precision mediump float;
precision highp int;

uniform mediump sampler2D uTexture;
uniform float u_intensity;

in vec2 vTextureCoord;
layout(location = 0) out vec4 fragColor;
in vec2 v_unitPosition_2318774107;

void main()
{
    float _105 = 1.0 - u_intensity;
    fragColor = texture(uTexture, vTextureCoord) * mat4(vec4(0.39300000667572021484375 + (0.60699999332427978515625 * _105), 0.768999993801116943359375 - (0.768999993801116943359375 * _105), 0.18899999558925628662109375 - (0.18899999558925628662109375 * _105), 0.0), vec4(0.3490000069141387939453125 - (0.3490000069141387939453125 * _105), 0.68599998950958251953125 + (0.31400001049041748046875 * _105), 0.16799999773502349853515625 - (0.16799999773502349853515625 * _105), 0.0), vec4(0.272000014781951904296875 - (0.272000014781951904296875 * _105), 0.533999979496002197265625 - (0.533999979496002197265625 * _105), 0.13099999725818634033203125 + (0.869000017642974853515625 * _105), 0.0), vec4(0.0, 0.0, 0.0, 1.0));
}
